import { render } from "./fb1.vue?vue&type=template&id=495dc13d&scoped=true"
import script from "./fb1.vue?vue&type=script&lang=js"
export * from "./fb1.vue?vue&type=script&lang=js"

import "./fb1.vue?vue&type=style&index=0&id=495dc13d&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495dc13d"]])

export default __exports__